import { ApiLoader, useApiResource } from './apiHelpers';

export interface CashdeskTargetOption {
  id: number;
  name: string;
}

export const CARD_TARGET_CATEGORY_ID = 10;

interface CashdeskTargetLists {
  categories: CashdeskTargetOption[];
  identifierTypes: CashdeskTargetOption[];
}

const EMPTY_LISTS: CashdeskTargetLists = { categories: [], identifierTypes: [] };

const toOptions = (raw: { member?: CashdeskTargetOption[] } | null): CashdeskTargetOption[] =>
  (raw?.member ?? []).map(({ id, name }) => ({ id, name }));

const loadTargetLists: ApiLoader<CashdeskTargetLists> = async authFetch => {
  const headers = { Accept: 'application/ld+json' };
  const [categories, identifierTypes] = await Promise.all([
    authFetch('/target_categories?visible=1&itemsPerPage=100', { method: 'GET', headers }),
    authFetch('/per_person_identifier_types?excluded=0&itemsPerPage=100', { method: 'GET', headers }),
  ]);
  return { categories: toOptions(categories), identifierTypes: toOptions(identifierTypes) };
};

const useCashdeskTargetOptions = (enabled: boolean) => {
  const { data, loading, error } = useApiResource(
    enabled ? loadTargetLists : null,
    EMPTY_LISTS,
    'Erreur de chargement des catégories de clients',
  );
  return { ...data, loading, error };
};

export default useCashdeskTargetOptions;
